<template>
  <div class="image-uploader">
    <h3 v-if="title">{{ title }}</h3>
    <v-flex class="py-1">
      <v-avatar v-if="innerModel" :tile="true">
        <img :src="innerModel" />
      </v-avatar>
      <v-btn
        v-if="innerModel && showRemoveImageBtn"
        color="error"
        @click="removeFile"
      >
        Remove image
      </v-btn>
      <e-upload
        v-else
        padding="py-0"
        :extensions="['jpeg', 'jpg', 'png', 'tiff', 'gif', 'bmp']"
        :directUpload="false"
        :showUploadBtn="showRemoveImageBtn"
        @filePicked="onFilePicked"
      />
    </v-flex>
    <transition name="slide-from-top">
      <span v-if="errorMessage" class="image-uploader__error-msg">
        {{ errorMessage }}
      </span>
    </transition>
  </div>
</template>

<script>
  import generateErrorMessage from '@/utils/generateErrorMsg'
  import EUpload from '@/components/shared/Upload'

  export default {
    name: 'EImageUploader',
    components: {
      EUpload
    },
    data () {
      return {
        innerModel: null
      }
    },
    props: {
      title: {
        type: String
      },
      showRemoveImageBtn: {
        type: Boolean,
        default: true
      },
      value: {
        type: [Array, String],
        required: true
      },
      error: {
        type: Object
      }
    },
    computed: {
      errorMessage () {
        return generateErrorMessage(this.error)
      }
    },
    watch: {
      value: {
        handler (val) {
          this.innerModel = val
        },
        immediate: true
      }
    },
    methods: {
      onFilePicked (file) {
        let reader = new FileReader()
        reader.onloadend = () => {
          this.innerModel = reader.result
          this.$emit('change', this.innerModel)
        }
        reader.readAsDataURL(file)
      },
      removeFile () {
        this.innerModel = ''
        this.$emit('change', this.innerModel)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .image-uploader {
    position: relative;
    padding-bottom: 20px;

    &__error-msg {
      position: absolute;
      color: #ff5252;
      font-size: 12px;
      bottom: 0;
    }
  }

  .slide-from-top {
    &-enter-active,
    &-leave-active {
      transition: all 0.3s;
      transform: translateY(0);
    }

    &-enter,
    &-leave-to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/EImageUploader/index.vue